import React from 'react';
import { MODO_IMPRESSAO } from '~/constants';

const AssinaturaSection = ({
    permissaoUsuarioVerAssinatura,
    dadosAssinatura,
    imagemAssinatura,
    imagemAssinaturaPrint,
    data,
    modoImpressao,
}) => {
  const impressaoA4 = modoImpressao === MODO_IMPRESSAO.A4;
  const largura = impressaoA4 ? 260 : '100%';
  const larguraMin = impressaoA4 ? 260 : 0;
  const fonte = impressaoA4 ? 'var(--regular-text-size)' : 'var(--small-text-size)';
  return (
<div
    className="assinatura-section scrollable"
    style={{
        padding: impressaoA4 ? 'var(--spacing-size)' : 'var(--half-spacing-size) var(--spacing-size)',
        paddingTop: impressaoA4 ? 0 : 'var(--half-spacing-size)',
        textAlign: "center",
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        marginTop:"auto",
        breakInside: 'avoid',
        pageBreakInside: 'avoid',
        overflowX: 'auto',
        ...(!impressaoA4 && { flex: '1 1 0', minWidth: 0 }),
    }}
>
    <div
        style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            ...(!impressaoA4 && { width: '100%' }),
        }}
    >
        {(dadosAssinatura && permissaoUsuarioVerAssinatura) && (
            <>
                <img
                    className="assinatura-tela"
                    src={imagemAssinatura}
                    style={{
                        maxWidth: 260,
                        width: largura,
                        maxHeight: 80,
                        minWidth: larguraMin,
                        minHeight: 5,
                        objectFit: "contain",
                    }}
                />

                <img
                    className="assinatura-print"
                    src={imagemAssinaturaPrint}
                    style={{
                        maxWidth: 260,
                        width: largura,
                        maxHeight: 80,
                        minWidth: larguraMin,
                        minHeight: 5,
                        objectFit: "contain",
                    }}
                />

                <div
                  style={{
                    maxWidth: 260,
                    width: largura,
                    maxHeight: 5,
                    minWidth: larguraMin,
                    minHeight: 5,
                  }}
                />
            </>
        )}
        {(!dadosAssinatura || !permissaoUsuarioVerAssinatura) && (
          <div
            style={{
              maxWidth: 260,
              width: largura,
              maxHeight: 50,
              minWidth: larguraMin,
              minHeight: 50,
            }}
          />
        )}

        <div
            className="assinatura-linha"
            style={{
                width: largura,
                marginTop: 'var(--half-spacing-size)',
                paddingTop: 'var(--half-spacing-size)',
                fontSize: fonte,
                fontWeight: 700,
            }}
        >
            ASSINATURA
        </div>

        <div
            style={{
                marginTop: 'var(--half-spacing-size)',
                fontSize: fonte,
                minHeight: 12,
            }}
        >
          {(data && permissaoUsuarioVerAssinatura)
              ? `${new Date(data).toLocaleDateString("pt-BR", {
                    day: "2-digit",
                    month: "long",
                    year: "numeric",
                })} às ${new Date(data).toLocaleTimeString("pt-BR", {
                    hour: "2-digit",
                    minute: "2-digit",
                })}`
              : (impressaoA4 ? "___ de ___________ de _______ às ___ : ___" : "__ de ________ de _____ às __ : __")}
        </div>

    </div>
</div>
);
};

export default AssinaturaSection;